export const getCurrentLocation = async (): Promise<GeolocationPosition> => {
  await navigator.permissions.query({ name: 'geolocation' });
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
};
